import React from "react";
import { heartFailureIntro } from "../../Util/writing";
import { getNarrowTextDivStyle } from "../../Util/util";

const HeartFailureIntro = (props) => {
  return <div style={getNarrowTextDivStyle(props.width)}>{heartFailureIntro}</div>;
};
export default HeartFailureIntro;
